import './css/stylesheet.css';
import Navigation from './navigation';
import Home from './articles/home';
import { CTPArticle } from './cyclo/CycloArticle';
import Desktop from './Desktop';
import React, { useState } from 'react';
import Resume from './articles/Resume';
import Shortcut from './shortcuts/Shortcut';

function App() {
  const [windows, setWindows] = useState(["Home"]);

  const removeWindow = (windowName) => 
    setWindows(windows.filter(function (window) {
      return window !== windowName;
  }));

  const addWindow = (windowName) => {
    if(!windows.includes(windowName)){
      setWindows([windowName, ...windows])
    }
  }

  return (
    <>
      <Navigation setWindows={addWindow}/>
      <Desktop>
        {windows.map((window) => {
          if(window === "Home"){
            return <Home setWindows={()=>removeWindow(window)} />
          }
          else if(window === "Resume"){
            return <Resume setWindows={()=>removeWindow(window)} />
          }
          else if(window === "CycloArticle"){
            return <CTPArticle setWindows={()=>removeWindow(window)} />
          }
        })
        }
      </Desktop>
    </>
  );
}

export default App;
